'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _numbro = require('numbro');

var _numbro2 = _interopRequireDefault(_numbro);

var _feeds = require('../../api/feeds');

var _loading = require('constructicon/loading');

var _loading2 = _interopRequireDefault(_loading);

var _metric = require('constructicon/metric');

var _metric2 = _interopRequireDefault(_metric);

var _ticker = require('constructicon/ticker');

var _ticker2 = _interopRequireDefault(_ticker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DonationTicker = function (_Component) {
  _inherits(DonationTicker, _Component);

  function DonationTicker() {
    _classCallCheck(this, DonationTicker);

    var _this = _possibleConstructorReturn(this, (DonationTicker.__proto__ || Object.getPrototypeOf(DonationTicker)).call(this));

    _this.fetchData = _this.fetchData.bind(_this);
    _this.formatDonation = _this.formatDonation.bind(_this);
    _this.state = {
      donations: [],
      status: 'fetching'
    };
    return _this;
  }

  _createClass(DonationTicker, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var refreshInterval = this.props.refreshInterval;

      this.fetchData();
      this.interval = refreshInterval && setInterval(this.fetchData, refreshInterval);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this.interval);
    }
  }, {
    key: 'fetchData',
    value: function fetchData() {
      var _this2 = this;

      var _props = this.props,
          campaign = _props.campaign,
          charity = _props.charity,
          event = _props.event,
          fetchAll = _props.fetchAll,
          includeOffline = _props.includeOffline,
          layout = _props.layout,
          page = _props.page,
          sort = _props.sort,
          team = _props.team;


      (0, _feeds.fetchDonationFeed)({
        campaign: campaign,
        charity: charity,
        event: event,
        fetchAll: fetchAll,
        includeOffline: includeOffline,
        page: page,
        sort: sort,
        team: team
      }).then(function (donations) {
        return donations.map(_feeds.deserializeDonation);
      }).then(function (donations) {
        return donations.filter(function (donation) {
          if (donation.anonymous) return false;
          if (layout.indexOf('amount') > -1) return !!donation.amount;
          if (layout.indexOf('message') > -1) return !!donation.message;
          if (layout.indexOf('name') > -1) return !!donation.name;
          return true;
        });
      }).then(function (donations) {
        return donations.map(function (donation) {
          return _this2.formatDonation(donation);
        });
      }).then(function (donations) {
        return _this2.setState({ donations: donations, status: 'fetched' });
      }).catch(function () {
        return _this2.setState({ status: 'failed' });
      });
    }
  }, {
    key: 'formatDonation',
    value: function formatDonation(donation) {
      var _props2 = this.props,
          layout = _props2.layout,
          format = _props2.format;

      var formattedAmount = (0, _numbro2.default)(donation.amount).formatCurrency(format);

      switch (layout) {
        case 'name-only':
          return donation.name;
        case 'amount-only':
          return formattedAmount;
        case 'message-only':
          return donation.message;
        case 'name-message':
          return _react2.default.createElement(
            'span',
            null,
            [donation.name, donation.message].join(' - ')
          );
        case 'message-amount':
          return _react2.default.createElement(
            'span',
            null,
            donation.message,
            ' ',
            _react2.default.createElement(
              'strong',
              null,
              formattedAmount
            )
          );
        case 'name-message-amount':
          return _react2.default.createElement(
            'span',
            null,
            [donation.name, donation.message].join(' - '),
            ' ',
            _react2.default.createElement(
              'strong',
              null,
              formattedAmount
            )
          );
        case 'amount-name':
          return _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(
              'strong',
              null,
              formattedAmount
            ),
            ' ',
            donation.name
          );
        default:
          return _react2.default.createElement(
            'span',
            null,
            donation.name,
            ' ',
            _react2.default.createElement(
              'strong',
              null,
              formattedAmount
            )
          );
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          label = _props3.label,
          ticker = _props3.ticker;
      var _state = this.state,
          donations = _state.donations,
          status = _state.status;


      return status === 'fetched' ? _react2.default.createElement(_ticker2.default, _extends({ label: label, items: donations }, ticker)) : status === 'failed' ? _react2.default.createElement(_metric2.default, { icon: 'warning', label: 'An error occurred' }) : _react2.default.createElement(_loading2.default, null);
    }
  }]);

  return DonationTicker;
}(_react.Component);

DonationTicker.propTypes = {
  /**
   * The campaign uid to fetch feed for
   */
  campaign: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.array]),

  /**
   * The charity uid to fetch feed for
   */
  charity: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.array]),

  /**
   * The event id to fetch feed for
   */
  event: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),

  /**
   * The page uid to fetch feed for
   */
  page: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.array]),

  /**
   * The team uid to fetch feed for
   */
  team: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.array]),

  /**
   * Donation amount format
   */
  format: _propTypes2.default.string,

  /**
   * Recursively fetch all donations (up to 5000)
   */
  fetchAll: _propTypes2.default.bool,

  /**
   * Donation display format
   */
  layout: _propTypes2.default.oneOf(['amount-name', 'name-amount', 'name-message', 'name-message-amount', 'message-amount', 'amount-only', 'name-only', 'message-only']),

  /**
   * Label text
   */
  label: _propTypes2.default.string,

  /**
   * Include offline donations
   */
  includeOffline: _propTypes2.default.bool,

  /**
   * Props to be passed to the Constructicon Ticker component
   */
  ticker: _propTypes2.default.object,

  /**
   * Interval (in milliseconds) to refresh data from API
   */
  refreshInterval: _propTypes2.default.number
};

DonationTicker.defaultProps = {
  fetchAll: false,
  format: '0,0[.]00',
  layout: 'name-amount',
  ticker: {}
};

exports.default = DonationTicker;


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/components/donation-ticker/index.js
// module id = 1339
// module chunks = 0